import { Component, HostBinding, OnInit } from '@angular/core';
import { Router } from '@angular/router';

@Component({
  selector: 'ballot-review-btn',
  templateUrl: './ballot-review-btn.component.html',
  styleUrls: ['./ballot-review-btn.component.scss']
})
export class BallotReviewBtnComponent implements OnInit {
  hideButton: boolean = false;
  constructor(private router: Router) {}

  ngOnInit() {
    this.hideMe();
  }

  hideMe() {
    if (this.router.url == "/landing") {
      this.hideButton = true;
    }
  }
  
  voteSummary() {
    this.router.navigate(['/ballot-review']);
  }

}



// WEBPACK FOOTER //
// ./src/app/features/ballot-review-btn/ballot-review-btn.component.ts